module.exports = __webpack_public_path__ + "img/lg_ring_r_skip_0_1@2x.e073dd8f.png";